import isString from 'lodash/isString';

var Area = function (area = {}) {
  if (isString(area.type)) {
    area.type = area.type.toLowerCase();
  }
  return {
    DATA_MODEL: 'Area',
    id: area.id,
    resourceId: area.resourceId,
    name: area.name,
    type: area.type || null,
  };
};

export default Area;
